import { useCallback, useEffect, useState } from "react";
import { Bug } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const ST = { yeni: ["Yeni", "bg-rose-50 text-rose-700 border-rose-200"], inceleniyor: ["İnceleniyor", "bg-amber-50 text-amber-800 border-amber-200"], cozuldu: ["Çözüldü", "bg-emerald-50 text-emerald-700 border-emerald-200"] };
const dt = (s) => (s ? new Date(s).toLocaleString("tr-TR") : "—");

function Row({ r, onSet }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <tr data-testid={`error-report-row-${r.id}`}>
        <td className="max-w-[320px]"><button className="text-left underline-offset-2 hover:underline" onClick={() => setOpen(!open)} data-testid={`error-report-toggle-${r.id}`}>{r.message}</button>
          <div className="text-[11px] text-slate-400">{r.platform} · {(r.routes || []).filter(Boolean).slice(0, 3).join(", ")}</div></td>
        <td className="text-right font-mono" data-testid={`error-report-count-${r.id}`}>{r.count}</td>
        <td className="text-[11px]">{dt(r.first_at)}<br />{dt(r.last_at)}</td>
        <td className="text-[11px]">{(r.users || []).slice(0, 3).join(", ")}</td>
        <td><select className={`h-7 text-[12px] rounded border px-1 ${ST[r.status][1]}`} value={r.status} onChange={(e) => onSet(r, e.target.value)} data-testid={`error-report-status-${r.id}`}>
          {Object.entries(ST).map(([k, [l]]) => <option key={k} value={k}>{l}</option>)}</select></td>
      </tr>
      {open && <tr><td colSpan={5} className="bg-slate-50">
        {(r.notes || []).map((n, i) => <div key={i} className="text-[12px] text-slate-700">“{n.note}” – {n.user || "anonim"} · {dt(n.at)}</div>)}
        <div className="text-[11px] text-slate-500">Sürüm {r.app_version || "—"} · Cihaz: {r.last?.device || "—"}</div>
        <pre className="text-[11px] whitespace-pre-wrap max-h-48 overflow-auto">{r.stack}</pre></td></tr>}
    </>
  );
}

export function ErrorReportsCard() {
  const [d, setD] = useState(null);
  const [f, setF] = useState("");
  const load = useCallback(() => api.get("/error-reports", { params: { status: f } }).then(({ data }) => setD(data)).catch((e) => toast.error(apiError(e))), [f]);
  useEffect(() => { load(); }, [load]);
  const onSet = async (r, status) => { try { await api.patch(`/error-reports/${r.id}`, { status }); load(); } catch (e) { toast.error(apiError(e)); } };
  return (
    <div className="panel p-4" data-testid="error-reports-card">
      <div className="flex items-center justify-between mb-2">
        <div className="font-semibold flex items-center gap-2"><Bug className="h-4 w-4" />Hata Raporları</div>
        <select className="h-8 border rounded text-[12px]" value={f} onChange={(e) => setF(e.target.value)} data-testid="error-reports-filter">
          <option value="">Tümü</option>{Object.entries(ST).map(([k, [l]]) => <option key={k} value={k}>{l} ({d?.counts?.[k] ?? 0})</option>)}</select>
      </div>
      {!d ? <div className="h-16 animate-pulse bg-slate-50 rounded" /> : d.items.length === 0 ? <p className="text-[13px] text-slate-500" data-testid="error-reports-empty">Kayıtlı hata raporu yok.</p> : (
        <div className="overflow-x-auto"><table className="erp-table text-[12px]"><thead><tr><th>Hata</th><th className="text-right">Tekrar</th><th>İlk / Son</th><th>Kullanıcılar</th><th>Durum</th></tr></thead>
          <tbody>{d.items.map((r) => <Row key={r.id} r={r} onSet={onSet} />)}</tbody></table></div>)}
    </div>
  );
}
